export const SearchConf = {
    query: {
        keys: [{
            key: 'id_yacht.yacht_name',
            operator: '$containsi'
        },
        {
            key: 'id_marina.marina',
            operator: '$containsi',
        },
        {
            key: 'id_yacht.id_attendance.id_provenence_list.provenence.provenence',
            operator: '$containsi',

        },
        {
            key: 'id_yacht.id_attendance.id_provenence_list.provenence_group.group',
            operator: '$containsi',

        }
        ]
    },
    placeholder: 'Search by yacht name, location or provenance',
    initialState: {
        value: ''
    },
}